export const data2_4 = [{
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}, {
    name: '',
    Jan_Room_Nts: '0',
    Jan_ADR: '0',
    Jan_Revenue: '0',
    Feb_Room_Nts: '0',
    Feb_ADR: '0',
    Feb_Revenue: '0',
    Mar_Room_Nts: '0',
    Mar_ADR: '0',
    Mar_Revenue: '0',
    Apr_Room_Nts: '0',
    Apr_ADR: '0',
    Apr_Revenue: '0',
    May_Room_Nts: '0',
    May_ADR: '0',
    May_Revenue: '0',
    Jun_Room_Nts: '0',
    Jun_ADR: '0',
    Jun_Revenue: '0',
    Jul_Room_Nts: '0',
    Jul_ADR: '0',
    Jul_Revenue: '0',
    Aug_Room_Nts: '0',
    Aug_ADR: '0',
    Aug_Revenue: '0',
    Sep_Room_Nts: '0',
    Sep_ADR: '0',
    Sep_Revenue: '0',
    Oct_Room_Nts: '0',
    Oct_ADR: '0',
    Oct_Revenue: '0',
    Nov_Room_Nts: '0',
    Nov_ADR: '0',
    Nov_Revenue: '0',
    Dec_Room_Nts: '0',
    Dec_ADR: '0',
    Dec_Revenue: '0',
    YTD_Room_Nts: '0',
    YTD_ADR: '0',
    YTD_Revenue: '0',
}];



export const defaultTitleData = {
    Jan: 0,
    Feb: 0,
    Mar: 0,
    Apr: 0,
    May: 0,
    Jun: 0,
    Jul: 0,
    Aug: 0,
    Sep: 0,
    Oct: 0,
    Nov: 0,
    Dec: 0,
    YTD: 0,
};


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-5/data.js